import url from 'url'
import $ from 'jquery'
/**
 * @module
 * @api
 */

/**
 * OLGA configuration loader
 * @param {Object} config
 * @constructor
 * @api
 */
export default function Loader(config) {
  $.extend(this, config || {})
  this.urlParameterKey = 'config'
}

/**
 * Loads config from JSON-file speciefied in URL. Eg) ?config=config1.json
 * If no config files i speciefied, default config is loaded
 * @param {Function} callback Called when config has been loaded
 * @param {String?} name Config file name to load, if not specificed will try to get it from querystring
 * @return {Object} Config
 */
Loader.prototype.loadConfig = function(callback, name) {
  var configPath = this.getConfigPath(name)

  if (!configPath) {
    callback({})
    return
  }

  $.ajax({
    dataType: 'json',
    url: configPath,
    success: function(config) {
      callback(config)
    },
    error: function(error) {
      this.ajaxErrorParser(error)
    }.bind(this)
  })
}

/**
 * Gets config file name from URL
 * @return {string=} config file name or null if no file name is specified
 */
Loader.prototype.getConfigNameFromUrl = function() {
  return url.parse(document.URL, true).query[this.urlParameterKey]
}

/**
 * Gets relative path to config file
 * @return {string}
 */
Loader.prototype.getConfigPath = function(name) {
  var configName = name || this.getConfigNameFromUrl()
  if (!configName) {
    return null
  }

  var path = this.basePath + '/' + configName

  return path
}

/**
 * Error handler for $.getJSON AJAX errors
 * @param {Object} ajaxError
 */
Loader.prototype.ajaxErrorParser = function(error) {
  var httpStatus, configPath

  httpStatus = error.status
  configPath = this.getConfigPath()

  switch (httpStatus) {
    case 200:
      this.displayError('MALFORMED_JSON')
      break

    case 404:
      this.displayError('NOT_FOUND', configPath)
      break

    default:
      this.displayError('UNKNOWN')
  }
}

/**
 * Displays an error message to the user
 * @param {string} errorCode
 * @param {string} moreInfo
 */
Loader.prototype.displayError = function(errorCode, moreInfo) {
  var errorMessage
  var errors = {
    MALFORMED_JSON: 'Config file is not a valid JSON-object.',
    NOT_FOUND: 'Config file not found.',
    UNKNOWN: 'Could not load config'
  }

  errorMessage = errors[errorCode]

  if (moreInfo) {
    errorMessage += ' (' + moreInfo + ')'
  }

  window.alert(errorMessage)
}

/**
 * Path to search for OLGA configuration files
 *
 * Note that only path can be changed, not protocol or host, because of the
 * [Same-origin policy](http://en.wikipedia.org/wiki/Same-origin_policy).
 *
 * Default is `config`.
 *
 * @type {string}
 * @memberof! module:config/Loader#
 * @api
 */
Loader.prototype.basePath = 'config'
